import { render, staticRenderFns } from "./HelpdeskTicketsCategories.vue?vue&type=template&id=26869c04&scoped=true"
import script from "./HelpdeskTicketsCategories.vue?vue&type=script&lang=js"
export * from "./HelpdeskTicketsCategories.vue?vue&type=script&lang=js"
import style0 from "./HelpdeskTicketsCategories.vue?vue&type=style&index=0&id=26869c04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26869c04",
  null
  
)

export default component.exports